<style scoped lang="scss">
	.main {
		min-width: 1024px;
	}
	.unbind-box {
		display: flex;
		align-items: center;
		justify-content: center;
    height: 285px;
		.iconfont {
			display: block;
			margin-bottom: 20px;
			font-size: 70px;
			line-height: 1;
			color: #eaeaea;
		}
    p {
      margin-bottom: 20px;
    }
  }

	.section-card {
		padding: 30px;
		background: #fff;
		box-shadow: 0 0 10px rgba(0,0,0,0.1);
		&.realtime-statics {
			min-height: 205px;
		}
		&.chart-statics {
			min-height: 318px;
		}
		.section-card-header {
			display: flex;
			align-items: flex-end;
			padding-bottom: 20px;
			.section-card-title {
				margin-right: 20px;
				font-size: 16px;
				font-weight: 600;
			}
			.header-small {
				flex: 1;
				font-size: 12px;
				color: #ccc;
			}
			.header-filters {
				display: flex;
				.filter-item {
					position: relative;
					padding: 0 15px;
					color: #999;
					font-size: 12px;
					&::after {
						position: absolute;
						left: 0;
						top: 20%;
						bottom: 20%;
						width: 1px;
						background: #efefef;
						content: "";
					}
					&:first-child::after {
						content: none;
					}
				}
			}
		}
	}

	.company {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 285px;
		.logo {
			margin-bottom: 20px;
			width: 70px;
			height: 70px;
			border-radius: 100%;
		}
		.name {
			margin-bottom: 10px;
			font-size: 14px;
		}
		.operate {
			padding-bottom: 50px;
		}
		.validity-period {
			display: flex;
			font-size: 12px;
			color: #999;
			.iconfont {
				margin-right: 10px;
				font-size: 12px;
			}
		}
	}

	.analysis {
		padding-left: 20px;
		padding-top: 10px;
		.label {
			font-size: 12px;
			color: #999;
		}
		.real-data {
			font-size: 20px;
			font-family: "Helvetica Neue";
			font-weight: 500;
		}
		.history-data {
			font-size: 12px;
			color: #ccc;
		}
	}

	.notices {
		padding-left: 20px;
		.notices-group {
			padding: 10px 0;
		}
		.subtitle {
			padding-bottom: 10px;
			font-size: 14px;
			color: #666;
		}
		.notice-item {
			font-size: 12px;
			color: #999;
			cursor:pointer;
		}
	}

	.quick-link {
		padding-left: 20px;
		.link-item {
			float: left;
			width: 230px;
			margin: 10px 0;
			color: #666;
			cursor:pointer;
			.iconfont {
				display: inline-block;
				margin-right: 10px;
				width: 25px;
				height: 25px;
				line-height: 25px;
				text-align: center;
				border-radius: 5px;
				color: #fff;
				font-size: 12px;
			}
		}
	}
</style>

<template>
	<div class="main">
			<el-row :gutter="20">
				<el-col :span="7">
          <template v-if="!isBind">
            <div class="section-card unbind-box">
      		    <div class="content-center">
      					<i class="iconfont icon-exclamation-triangle"></i>
      		      <p>您尚未绑定认证服务号，请先绑定!</p>
      		      <el-button type="primary" @click="handleBind">去绑定</el-button>
      		    </div>
      		  </div>
          </template>
          <template v-else>
  					<section class="section-card company">
  						<img class="logo" v-if="authorizerData" :src="authorizerData.head_img || 'https://fakeimg.pl/70x70/EFEFEF/CCC/?text=brand&font=lobster'">
  						<div class="name">{{authorizerData.principal_name}}</div>
  						<div class="operate">
  							<el-button v-if="isBind" type="default" size="mini" @click="handleBind">更新授权</el-button>
  							<el-button v-else type="default" size="mini" @click="handleBind">去授权</el-button>
  							<el-button type="danger" size="mini" @click="accountactivate">账号续费</el-button>
  						</div>
  						<div class="validity-period" v-if="activateInfo"><i class="iconfont icon-clock"></i>{{activateInfo.expired_at | datetime('yyyy-MM-dd hh:mm:ss')}} 到期</div>
  					</section>
          </template>
				</el-col>
				<el-col :span="17">
					<section class="section-card realtime-statics" v-loading="userloading">
						<div class="section-card-header">
							<div class="section-card-title">
								实时概况
							</div>
							<div class="header-small">
								更新时间：{{Date.now()/1000 | datetime('yyyy-MM-dd hh:mm:ss')}}
							</div>
							<!-- <ul class="header-filters">
								<li class="filter-item">全店</li>
								<li class="filter-item">网店</li>
								<li class="filter-item">所有门店</li>
							</ul> -->
						</div>
						<div>
							<el-row class="analysis" :gutter="20">
								<el-col :span="12">
									<div class="view-flex">
										<div class="view-flex-item">
											<div class="label">实付金额(元)</div>
											<div class="real-data" v-if="staticsData">{{staticsData.today_data.real_payed_fee/100 | keepTwoDecimalFull}}</div>
											<div class="history-data" v-if="staticsData">昨日：{{staticsData.yesterday_data.real_payed_fee/100 | keepTwoDecimalFull}}</div>
										</div>
										<div class="view-flex-item">
											<div class="label">支付订单数</div>
											<div class="real-data">{{staticsData && staticsData.today_data.real_payed_orders}}</div>
											<div class="history-data">昨日：{{staticsData && staticsData.yesterday_data.real_payed_orders}}</div>
										</div>
									</div>
								</el-col>
								<el-col :span="12">
									<div class="view-flex">
										<div class="view-flex-item">
											<div class="label">实付会员数</div>
											<div class="real-data">{{staticsData && staticsData.today_data.real_payed_members}}</div>
											<div class="history-data">昨日：{{staticsData && staticsData.yesterday_data.real_payed_members}}</div>
										</div>
										<div class="view-flex-item">
											<div class="label">客单价(元)</div>
											<div class="real-data" v-if="staticsData">{{staticsData.today_data.real_atv/100 | keepTwoDecimalFull}}</div>
											<div class="history-data" v-if="staticsData">昨日：{{staticsData.yesterday_data.real_atv/100 | keepTwoDecimalFull}}</div>
										</div>
									</div>
								</el-col>
							</el-row>
							<el-row class="analysis" :gutter="20">
								<el-col :span="12">
									<div class="view-flex">
										<div class="view-flex-item">
											<div class="label">退款金额(元)</div>
											<div class="real-data" v-if="staticsData">{{staticsData.today_data.real_refunded_fee/100 | keepTwoDecimalFull}}</div>
											<div class="history-data" v-if="staticsData">昨日：{{staticsData.yesterday_data.real_refunded_fee/100 | keepTwoDecimalFull}}</div>
										</div>
										<div class="view-flex-item">
											<div class="label">售后订单数</div>
											<div class="real-data">{{staticsData && staticsData.today_data.real_aftersale_count}}</div>
											<div class="history-data">昨日：{{staticsData && staticsData.yesterday_data.real_aftersale_count}}</div>
										</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="view-flex">
										<div class="view-flex-item">
											<div class="label">实新增储值金额(元)</div>
											<div class="real-data" v-if="staticsData">{{staticsData.today_data.real_deposit/100 | keepTwoDecimalFull}}</div>
											<div class="history-data" v-if="staticsData">昨日：{{staticsData.yesterday_data.real_deposit/100 | keepTwoDecimalFull}}</div>
										</div>
									</div>
								</el-col>
                <el-col :span="6">
                	<div class="view-flex">
                		<div class="view-flex-item">
                			<div class="label">当天实付金额(元)</div>
                			<div class="real-data" v-if="staticsData">
                          <div class="real-data"> <span >{{staticsData.now_data.total_fee/100 | keepTwoDecimalFull}}</span></div>
                           <div class="label">退款: <span>{{staticsData.now_data.refund_fee/100 | keepTwoDecimalFull}}</span></div>
                           <div class="label">售后退款: <span>{{staticsData.now_data.aftersales_fee/100 | keepTwoDecimalFull}}</span></div>
                      </div>
                		</div>
                	</div>
                </el-col>
							</el-row>
              <el-row :gutter="20" class="analysis">
                <el-col :span="6">
                	<div class="view-flex">
                		<div class="view-flex-item">
                			<div class="label">到家实付/(元)</div>
                			<div class="real-data" v-if="staticsData">
                          <div class="real-data"> <span >{{staticsData.source_data.yaoking_amount_payed_count/100 | keepTwoDecimalFull}}</span></div>
                           <div class="label">退款: <span>{{staticsData.source_data.yaoking_refunded_count/100 | keepTwoDecimalFull}}</span></div>
                           <div class="label">售后退款: <span>{{staticsData.source_data.yaoking_aftersales_fee/100 | keepTwoDecimalFull}}</span></div>
                      </div>
                		</div>
                	</div>
                </el-col>
                <el-col :span="6">
                	<div class="view-flex">
                		<div class="view-flex-item">
                			<div class="label">优选实付/(元)</div>
                			<div class="real-data" v-if="staticsData">
                          <div class="real-data"> <span >{{staticsData.source_data.yx_amount_payed_count/100 | keepTwoDecimalFull}}</span></div>
                           <div class="label">退款: <span>{{staticsData.source_data.yx_refunded_count/100 | keepTwoDecimalFull}}</span></div>
                            <div class="label">售后退款: <span>{{staticsData.source_data.yx_aftersales_fee/100 | keepTwoDecimalFull}}</span></div>
                      </div>
                		</div>
                	</div>
                </el-col>
              </el-row>
						</div>
					</section>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="10">
					<section class="section-card" v-loading="userloading">
						<div class="section-card-header">
							<div class="section-card-title">
								重要提醒
							</div>
						</div>
						<div class="notices">
							<div class="notices-group">
								<div class="subtitle">订单相关</div>
								<el-row>
									<el-col class="notice-item" :span="12"><router-link to="/order/entitytrade/tradenormalorders?tab=notship">待发货订单：{{staticsData && staticsData.notice_data.wait_delivery_count}}</router-link></el-col>
									<el-col class="notice-item" :span="12" ><a @click="toLink('aftersaleslist')">待处理退款：{{staticsData && staticsData.notice_data.aftersales_count}}</a></el-col>
                  <el-col class="notice-item" :span="12" ><router-link to="/order/Refunderrorlogs">退款失败待处理：{{staticsData && staticsData.notice_data.refund_errorlogs_count}}</router-link></el-col>
								</el-row>
							</div>
							<div class="notices-group">
								<div class="subtitle">商品相关</div>
								<el-row>
                  <el-col class="notice-item" :span="12"><router-link to="/entity/goods/goodsphysical">总商品：{{staticsData && staticsData.notice_data.all_goods_count}}</router-link></el-col>
                  <el-col class="notice-item" :span="12"><router-link to="/entity/goods/goodsphysical?approve_status=onsale">实时在线产品数量：{{staticsData && staticsData.notice_data.up_goods_count}}</router-link></el-col>
                  <el-col class="notice-item" :span="12"><router-link to="/entity/goods/goodsphysical?approve_status=instock">下架商品：{{staticsData && staticsData.notice_data.down_goods_count}}</router-link></el-col>
									<el-col class="notice-item" :span="12"><router-link to="/entity/goods/goodsphysical?tab=second">库存预警商品：{{staticsData && staticsData.notice_data.warning_goods_count}}</router-link></el-col>

								</el-row>
							</div>
							<div class="notices-group">
								<div class="subtitle">营销相关</div>
								<el-row>
									<el-col class="notice-item" :span="12"><router-link to="/marketing/marketingseckill?status=in_sale">进行中的秒杀：{{staticsData && staticsData.notice_data.started_seckill_count}}</router-link></el-col>
									<el-col class="notice-item" :span="12"><router-link to="/marketing/groupsindex?activeName=third">进行中的拼团：{{staticsData && staticsData.notice_data.started_gtoups_count}}</router-link></el-col>
								</el-row>
							</div>
						</div>
					</section>
				</el-col>
				<el-col :span="14">
					<section class="section-card chart-statics" v-loading="userloading">
						<canvas id="canvas" height="120"></canvas>
					</section>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<section class="section-card">
						<div class="section-card-header">
							<div class="section-card-title">
								常用功能
							</div>
						</div>
						<div class="quick-link clearfix">
							<div class="link-item" v-for="(item, index) in links" :key="index" @click="toLink(item.link)"><i class="iconfont" :class="'icon-'+item.icon" :style="'background:'+ item.color"></i>{{item.text}}</div>
						</div>
					</section>
				</el-col>
			</el-row>
    <section class="section-card">
      <el-row :span="20">
        <div class="section-card-header">
          <div class="section-card-title">
            昨日销量排行
          </div>
        </div>
        <el-table
          :data="tableData"
          stripe
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="item_bn"
            label="商品货号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="item_name"
            label="商品名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价/元"
            width="180">
          </el-table-column>
          <el-table-column
            prop="sales_count"
            label="新增销量">
          </el-table-column>
          <el-table-column
            prop="fixed_amount_count"
            label="新增成交额(优惠前)/（元）">
          </el-table-column>
          <el-table-column
            prop="settle_amount_count"
            label="新增成交额(实付价)/（元）">
          </el-table-column>
        </el-table>
      </el-row>
    </section>

		<!-- <el-dialog class="industry-dialog" title="提示" :visible="waitingDialog" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
      <span>请在微信端窗口进行微信公众号授权</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneBind">完成授权</el-button>
        <el-button @click="bindWebChatagain">重  试</el-button>
      </span>
    </el-dialog> -->
	</div>

</template>

<script>
  import { Message } from 'element-ui'
  import store from '../../store'
  import { getWechatPreAuthUrl, getWechatBind, getAuthorizerInfo, getUserWeekSummary } from '../../api/wechat'
  import { getActivateInfo, updateCompanyInfo, getResourceList, getCompanyStatistics } from '../../api/company'
  import {getPlatformTopList} from "../../api/platform";
  import chart from 'chart.js'
  import countDown from '../../components/countdown'

  export default {
    data () {
      return {
        userloading: true,
        authorizerData: {
          principal_name: ''
        },
		  activateInfo: {},
        tableData:[],
        url: '',
        isBind: false,
        isBindFail: false,
        state: 1,
        industryVisible: false,
        guideHidden: true,
        storeHidden: false,
        webchatHidden: false,
        waitingDialog: false,
        checkedGuide: {},
        checkedStore: {},
		staticsData: '',
		userTimeArr: [],
        userData: [],
				vipData: [],
				svipData: [],
        i: -1,
        guideList: [
          { id: '1', icon: 'icon-marketing', name: '超市便利', desc: '大型商超，超市，便利店，小卖部等' },
          { id: '2', icon: 'icon-baking', name: '烘培奶茶', desc: '蛋糕店，奶茶店，甜品店，面包房等' },
          { id: '3', icon: 'icon-play', name: '娱乐休闲', desc: 'KTV，桌球，桑拿汗蒸，按摩足浴等' },
          { id: '4', icon: 'icon-fresh', name: '水果生鲜', desc: '水果摊，生鲜菜场等' },
          { id: '5', icon: 'icon-housekeeping', name: '生活服务', desc: '保洁，保姆，钟点工，月嫂等' },
          { id: '6', icon: 'icon-beauty', name: '美容健身', desc: '健身房，美容店，美发店，美甲店等'  },
          { id: '7', icon: 'icon-coffee', name: '咖啡桌游', desc: '咖啡馆，桌游室，棋牌室，轰趴馆等'  },
          { id: '8', icon: 'icon-food', name: '餐饮', desc: '小吃店，菜馆，自助餐，快餐店等' }
        ],
        storeList: [
          { id: 1, icon: 'icon-store', text: '1家门店', bgOther: false },
          { id: 2, icon: 'icon-stores', text: '2-4家门店', bgOther: true },
          { id: 3, icon: 'icon-stores', text: '5-30家门店', bgOther: true },
          { id: 4, icon: 'icon-stores', text: '31-100家门店', bgOther: true },
          { id: 3, icon: 'icon-stores', text: '100家以上', bgOther: true }
        ],
        currGuide: {},
				links: [{
					link: 'goodsphysical_editor',
					icon: 'box',
					color: '#fa888b',
					text: '新增实体商品'
				},
				{
					link: 'servicegoods_editor',
					icon: 'user-clock',
					color: '#b992f8',
					text: '新增服务商品'
				},
				{
					link: 'groupsindex_editor',
					icon: 'comments-dollar',
					color: '#fa9678',
					text: '新增拼团活动'
				},
				{
					link: 'membermarketing',
					icon: 'ticket-alt',
					color: '#fa8084',
					text: '新增优惠券'
				},
				{
					link: 'marketingseckill_editor',
					icon: 'stopwatch',
					color: '#f9ca6b',
					text: '新增秒杀活动'
				},
				{
					link: 'marketingcommunityactivity_editor',
					icon: 'door-open',
					color: '#65d7f3',
					text: '新增社区活动'
				},
				{
					link: 'marketingdeliveryorder',
					icon: 'dolly-flatbed',
					color: '#fb9f5a',
					text: '配送单处理'
				},
				{
					link: 'tradenormalorders',
					icon: 'clipboard-list',
					color: '#7cc0f4',
					text: '实体订单处理'
				},
				{
					link: 'aftersaleslist',
					icon: 'user-tie',
					color: '#fa8084',
					text: '售后处理'
				},
				{
					link: 'popularizewithdraw',
					icon: 'donate',
					color: '#fa9679',
					text: '提现处理'
				}]
      }
    },
    methods: {
    	toLink (link) {
				this.$router.push({path: this.matchInternalRoute(link)})
			},
      handleBind () {
        if (this.url) {
          var metadata = document.getElementsByTagName("meta");
          for(var i=0; i<metadata.length; i++) {
            if(metadata[i]["name"] == "referrer") {
              metadata[i]["content"] = "default"
            }
          }
          window.open(this.url, '_blank')
        }
      },
      accountactivate () {
        this.$router.push({path: this.matchInternalRoute('assetaccountactivation')})
      },
      // 获取用户列表
      getUrl: function () {
        // NProgress.start()
        let params = {
          callback_url: this.wxAuthCallbackUrl + 'auth/woa'
        }
        getWechatPreAuthUrl(params).then(response => {
          this.url = response.data.data.url
        })
      },
      getTopList:function(){
    	    getPlatformTopList().then(response => {
              this.tableData = response.data.data
          })
      },
      guideChoose: function (item, index) {
        this.currGuide = item
        this.i = index
        this.guideHidden = false
        this.storeHidden = true
        this.state = 2
        this.checkedGuide = item
        let params = {
          industry: item.name
        }
        updateCompanyInfo(params).then(res => {
        })
      },
      storeChoose: function (item, index) {
        this.state = 3
        this.storeHidden = false
        this.webchatHidden = true
        this.checkedStore = item
      },
      bindWebChat: function () {
        this.webchatHidden = false
        this.waitingDialog = true
        this.industryVisible = false
        if (this.url) {
          for(var i=0; i<metadata.length; i++) {
            if(metadata[i]["name"] == "referrer") {
              metadata[i]["content"] = "default"
            }
          }
          window.open(this.url, "_blank")
        }
      },
      doneBind: function () {
        if (!this.isBind) {
          this.industryVisible = true
          this.webchatHidden = true
        }
        this.waitingDialog = false
      },
      bindWebChatagain: function () {
        if (this.url) {
          for(var i=0; i<metadata.length; i++) {
            if(metadata[i]["name"] == "referrer") {
              metadata[i]["content"] = "default"
            }
          }
          window.open(this.url, "_blank")
        }
      },
      unBind () {
        this.industryVisible = false
        this.waitingDialog = false
      },
      chartInit () {
        window.chartColors = {
          red: 'rgb(255, 99, 132)',
          orange: 'rgb(255, 159, 64)',
          yellow: 'rgb(255, 205, 86)',
          green: 'rgb(75, 192, 192)',
          blue: 'rgb(54, 162, 235)',
          purple: 'rgb(153, 102, 255)',
          grey: 'rgb(201, 203, 207)'
        };
        var config = {
            type: 'line',
            data: {
                labels: this.userTimeArr,
                datasets: [{
                    label: '新增人数',
                    backgroundColor: window.chartColors.red,
                    borderColor: window.chartColors.red,
                    data: this.userData,
                    fill: false,
                },
								{
										label: '新增vip',
										backgroundColor: window.chartColors.orange,
										borderColor: window.chartColors.orange,
										data: this.vipData,
										fill: false,
								},
								{
										label: '新增svip',
										backgroundColor: window.chartColors.yellow,
										borderColor: window.chartColors.yellow,
										data: this.svipData,
										fill: false,
								}]
            },
            options: {
              responsive: true,
              title:{
                display:true,
                text:'近7天用户趋势'
              },
              tooltips: {
                mode: 'index',
                intersect: true,
              },
              hover: {
                mode: 'nearest',
                intersect: true
              },
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: '',
                  }
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: false,
                  }
                }]
              }
            }
        };
        if(document.getElementById("canvas")!=null)
        {
        	var ctx = document.getElementById("canvas").getContext("2d");
        	window.myLine = new Chart(ctx, config);
        }

      }
    },
    mounted () {
      this.getTopList();
      getActivateInfo().then(res => {
        this.activateInfo = res.data.data
        if(!res.data.data.is_valid) {
          this.$router.push({path: this.matchInternalRoute('assetaccountactivation')})
        }
      })
      this.getUrl()
      getCompanyStatistics().then(res => {
        this.staticsData = res.data.data
        let memberData = res.data.data.member_data
        for (var key in memberData) {
          this.userTimeArr.push(key)
          this.userData.push(memberData[key].newAddMember)
          this.vipData.push(memberData[key].vipMember)
          this.svipData.push(memberData[key].svipMember)
        }
        this.$nextTick(() => {
          this.chartInit()
          this.userloading = false
        })
      })
      if (this.$route.query) {
        this.isBindFail = this.$route.query.isBindFail
      }
      if(this.isBindFail) {
        this.waitingDialog = true
        return
      }
      if (store.getters.is_authorizer) {
        this.isBind = true
        getAuthorizerInfo().then(response => {
          this.authorizerData = response.data.data
        })
      } else {
        this.industryVisible = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?0460b9f6